/* ======================================================================
   logo-mockup.js (MODAL ONLY) — FULL VERSION (MOBILE + AUTO EMBROIDERY)

   ✅ Display rules
   - Tool shows ONLY if product has tag: "mockup_display"
   - Embroidery effect is applied automatically ONLY if product has tag: "mockup_brod"
   - The embroidery button is NOT displayed in the modal

   ✅ Mobile
   - Responsive modal: desktop 2 cols, mobile 1 col
   - Stage uses svh + visualViewport resize handling
   - Touch-friendly Konva transformer anchors
   - Body scroll is locked while modal is open

   ✅ Features
   - Upload logo: SVG / PNG / JPG
   - Background removal (LOCAL) for PNG/JPG + tolerance slider
   - Rotate/scale/move logo (Konva Transformer)
   - Thumbnails paginated by 12 with arrows
   - Export/download mockup PNG (keeps base image ratio; no transformer handles in export)

   IMPORTANT (recommended to make tag detection 100% reliable):
   Add on #logo-mockup-root in Liquid:
     data-product-tags="{{ product.tags | join: '|' | escape }}"
   ====================================================================== */

(() => {
  /* =========================
     BEGIN YOURAPP: Feature flag (global show/hide)
     ========================= */
  const ENABLE_MOCKUP_BUTTON = true; // set false to hide sitewide
  /* =======================
     END YOURAPP: Feature flag
     ======================= */

  /* =========================
     BEGIN YOURAPP: BUTTON STYLE SETTINGS (theme button #logo-mockup-open)
     ========================= */
  const MOCKUP_BUTTON_STYLE = {
    // padding (inner)
    paddingTop: "12px",
    paddingRight: "18px",
    paddingBottom: "12px",
    paddingLeft: "18px",

    // margin (outer)
    marginTop: "0px",
    marginRight: "0px",
    marginBottom: "20px",
    marginLeft: "0px",

    // radius
    borderRadius: "30px",

    // border
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#111111",

    // background + text
    backgroundColor: "transparent",
    textColor: "inherit"
  };
  /* =======================
     END YOURAPP: BUTTON STYLE SETTINGS
     ======================= */

  /* =========================
     BEGIN YOURAPP: EMBROIDERY SETTINGS (editable)
     - Applied automatically if product has tag "mockup_brod"
     ========================= */
  const EMBROIDERY_TAG = "mockup_brod"; // Shopify tag to auto-apply embroidery

  const EMBROIDERY_SETTINGS = {
    enabled: true,

    // quality
    maxSize: 1800,

    // stitch look
    angleDeg: -25,
    stitchSpacing: 3,
    stitchLength: 14,
    threadWidth: 1.6,

    // intensity / shading
    textureOpacity: 0.60,
    bevelStrength: 0.65,
    shadowStrength: 0.30,
    innerShadowStrength: 0.25,
    edgeStrength: 0.40
  };
  /* =======================
     END YOURAPP: EMBROIDERY SETTINGS
     ======================= */

  /* =========================
     BEGIN YOURAPP: Guards
     ========================= */
  const root = document.getElementById("logo-mockup-root");
  if (!root) return;
  if (!window.Konva) return;
  /* =======================
     END YOURAPP: Guards
     ======================= */

  /* =========================
     BEGIN YOURAPP: i18n (/en/)
     ========================= */
  const isEN = /\/en(\/|$)/.test(window.location.pathname);

  const I18N = {
    fr: {
      title: "Mockup",
      uploadHint: "Importez votre logo (SVG/PNG/JPG).",
      loadingImg: "Chargement image…",
      loadingLogo: "Chargement logo…",
      changeImg: "Changement d’image…",
      removeBg: "Supprimer le fond",
      removingBg: "Suppression du fond…",
      removedBgOk: "Fond supprimé ✅",
      download: "Télécharger le mockup",
      downloading: "Téléchargement…",
      errBg: "Échec suppression de fond.",
      needLogo: "Ajoutez un logo d’abord.",
      previewRequired: "Ajoutez un logo (SVG/PNG/JPG) pour générer le mockup.",
      bgSensitivity: "Sensibilité du fond",
      bgSensitivityHelp: "Plus élevé = supprime plus (risque d’attaquer le logo).",
      svgNoBg: "La suppression de fond fonctionne uniquement pour PNG/JPG. Pour un SVG, exportez en PNG/JPG.",
      unsupported: "Format non supporté. Merci d’envoyer SVG/PNG/JPG.",
      editorNotReady: "Zone d’édition non prête. Réessayez.",
      imageLoadFail: "Impossible de charger l’image produit.",
      chooseLogo: "Choisir mon logo",
      accepted: "(fichiers acceptés : SVG, PNG et JPG)",
      noFile: "Aucun fichier choisi",
      pickImage: "Choisir une image",
      actions: "Actions",
      disabledByTag: "Outil désactivé (mockup_display manquant).",
      embroidering: "Application effet broderie…",
      embroideryOk: "Effet broderie appliqué ✅",
      embroideryFail: "Effet broderie impossible (merci de re-téléverser le logo)."
    },
    en: {
      title: "Mockup",
      uploadHint: "Upload your logo (SVG/PNG/JPG).",
      loadingImg: "Loading image…",
      loadingLogo: "Loading logo…",
      changeImg: "Switching image…",
      removeBg: "Remove background",
      removingBg: "Removing background…",
      removedBgOk: "Background removed ✅",
      download: "Download mockup",
      downloading: "Downloading…",
      errBg: "Background removal failed.",
      needLogo: "Please add a logo first.",
      previewRequired: "Please add a logo (SVG/PNG/JPG) to generate the mockup.",
      bgSensitivity: "Background sensitivity",
      bgSensitivityHelp: "Higher = removes more (may eat into the logo).",
      svgNoBg: "Background removal works for PNG/JPG only. For SVG, export to PNG/JPG.",
      unsupported: "Unsupported format. Please upload SVG/PNG/JPG.",
      editorNotReady: "Editor area not ready. Please retry.",
      imageLoadFail: "Unable to load product image.",
      chooseLogo: "Choose my logo",
      accepted: "(accepted files: SVG, PNG, JPG)",
      noFile: "No file chosen",
      pickImage: "Choose an image",
      actions: "Actions",
      disabledByTag: "Tool disabled (missing mockup_display tag).",
      embroidering: "Applying embroidery effect…",
      embroideryOk: "Embroidery effect applied ✅",
      embroideryFail: "Embroidery effect failed (please re-upload logo)."
    }
  };

  const t = (key) => (isEN ? I18N.en : I18N.fr)[key] || key;
  /* =======================
     END YOURAPP: i18n (/en/)
     ======================= */

  /* =========================
     BEGIN YOURAPP: Tag gate
     - show ONLY if tag "mockup_display"
     - auto embroidery if tag "mockup_brod"
     ========================= */
  function safeJson(s) {
    try { return JSON.parse(s); } catch { return null; }
  }

  function parseTagsStr(s) {
    if (!s) return [];
    return String(s).split(/[\|\,,;]/g).map((x) => x.trim()).filter(Boolean);
  }

  function getTagsBestEffort() {
    // 1) Recommended: data-product-tags on #logo-mockup-root
    const fromData = parseTagsStr(root.dataset.productTags);
    if (fromData.length) return fromData;

    // 2) theme JSON scripts
    const scripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
    for (const s of scripts) {
      const txt = s.textContent?.trim();
      if (!txt || txt.length < 20) continue;
      const j = safeJson(txt);
      if (j && Array.isArray(j.tags)) return j.tags.map(String);
      if (j && j.product && Array.isArray(j.product.tags)) return j.product.tags.map(String);
    }

    // 3) ShopifyAnalytics meta
    const meta = window.ShopifyAnalytics?.meta?.product;
    if (meta && Array.isArray(meta.tags)) return meta.tags.map(String);

    return [];
  }

  function hasTag(tag) {
    const tags = getTagsBestEffort().map((x) => x.toLowerCase());
    return tags.includes(String(tag).toLowerCase());
  }

  function hasDisplayTag() {
    return hasTag("mockup_display");
  }

  function hasEmbroideryTag() {
    return hasTag(EMBROIDERY_TAG);
  }

  const SHOULD_AUTO_EMBROIDER = () => EMBROIDERY_SETTINGS.enabled && hasEmbroideryTag();

  function applyButtonStyle(btn) {
    if (!btn) return;

    btn.style.paddingTop = MOCKUP_BUTTON_STYLE.paddingTop;
    btn.style.paddingRight = MOCKUP_BUTTON_STYLE.paddingRight;
    btn.style.paddingBottom = MOCKUP_BUTTON_STYLE.paddingBottom;
    btn.style.paddingLeft = MOCKUP_BUTTON_STYLE.paddingLeft;

    btn.style.marginTop = MOCKUP_BUTTON_STYLE.marginTop;
    btn.style.marginRight = MOCKUP_BUTTON_STYLE.marginRight;
    btn.style.marginBottom = MOCKUP_BUTTON_STYLE.marginBottom;
    btn.style.marginLeft = MOCKUP_BUTTON_STYLE.marginLeft;

    btn.style.borderRadius = MOCKUP_BUTTON_STYLE.borderRadius;

    btn.style.borderWidth = MOCKUP_BUTTON_STYLE.borderWidth;
    btn.style.borderStyle = MOCKUP_BUTTON_STYLE.borderStyle;
    btn.style.borderColor = MOCKUP_BUTTON_STYLE.borderColor;

    btn.style.backgroundColor = MOCKUP_BUTTON_STYLE.backgroundColor;
    btn.style.color = MOCKUP_BUTTON_STYLE.textColor;

    if (String(MOCKUP_BUTTON_STYLE.borderStyle).toLowerCase() === "none") {
      btn.style.borderWidth = "0px";
    }
  }

  function applyMockupButtonVisibility() {
    const btn = document.getElementById("logo-mockup-open");
    if (!btn) return;

    applyButtonStyle(btn);

    const enabled = ENABLE_MOCKUP_BUTTON && hasDisplayTag();
    btn.style.display = enabled ? "" : "none";
    btn.setAttribute("aria-hidden", enabled ? "false" : "true");
    if (!enabled) btn.setAttribute("title", t("disabledByTag"));
  }

  applyMockupButtonVisibility();
  if (!ENABLE_MOCKUP_BUTTON || !hasDisplayTag()) return;
  /* =======================
     END YOURAPP: Tag gate
     ======================= */

  /* =========================
     BEGIN YOURAPP: Read config
     ========================= */
  const images = safeJson(root.dataset.images || "[]") || [];

  const zonesCfg = safeJson(root.dataset.zones || "null");
  const hasZone =
    !!(
      zonesCfg &&
      zonesCfg.zone &&
      typeof zonesCfg.zone.x === "number" &&
      typeof zonesCfg.zone.y === "number" &&
      typeof zonesCfg.zone.w === "number" &&
      typeof zonesCfg.zone.h === "number"
    );

  const zoneRelDefault = hasZone ? zonesCfg.zone : { x: 0, y: 0, w: 1, h: 1 };
  const dpoSelector = root.dataset.dpoSelector || "input[name='properties[Logo]']";
  /* =======================
     END YOURAPP: Read config
     ======================= */

  /* =========================
     BEGIN YOURAPP: Helpers
     ========================= */
  const isMobile = () =>
    window.matchMedia("(max-width: 900px)").matches ||
    window.matchMedia("(pointer: coarse)").matches;

  function nextFrame() { return new Promise((r) => requestAnimationFrame(r)); }

  async function waitForLayout(el, tries = 16) {
    for (let i = 0; i < tries; i++) {
      await nextFrame();
      const rect = el.getBoundingClientRect();
      const w = Math.round(rect.width);
      const h = Math.round(rect.height);
      if (w > 0 && h > 0) return { w, h };

      if (i === 3 && (!h || h < 50)) {
        el.style.height = isMobile() ? "52svh" : "520px";
        el.style.minHeight = isMobile() ? "320px" : "360px";
        el.style.display = "block";
      }
    }
    const rect = el.getBoundingClientRect();
    return { w: Math.round(rect.width), h: Math.round(rect.height) };
  }

  // keep base ratio, left aligned, vertically centered
  function fitRectContainLeftCenter(iw, ih, cw, ch) {
    const ir = iw / ih;
    const cr = cw / ch;
    let w, h;
    if (ir > cr) { w = cw; h = cw / ir; }
    else { h = ch; w = ch * ir; }
    return { x: 0, y: (ch - h) / 2, width: w, height: h };
  }

  function extOf(name = "") {
    const m = name.toLowerCase().match(/\.([a-z0-9]+)$/);
    return m ? m[1] : "";
  }
  const isRasterExt = (ext) => ext === "png" || ext === "jpg" || ext === "jpeg";
  const isSvgExt = (ext) => ext === "svg";

  async function loadImage(url) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    await img.decode();
    return img;
  }

  async function fetchBlob(url) {
    const r = await fetch(url, { mode: "cors" });
    if (!r.ok) throw new Error("fetch failed");
    return await r.blob();
  }

  function fileFromBlob(blob, name) {
    return new File([blob], name, { type: blob.type || "application/octet-stream" });
  }

  async function svgFileToHTMLImage(svgFile) {
    const svgText = await svgFile.text();
    const safeText = svgText.includes("xmlns=")
      ? svgText
      : svgText.replace("<svg", '<svg xmlns="http://www.w3.org/2000/svg"');

    const encoded = encodeURIComponent(safeText).replace(/'/g, "%27").replace(/"/g, "%22");
    const dataUrl = `data:image/svg+xml;charset=utf-8,${encoded}`;

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = dataUrl;
    await img.decode();
    return img;
  }

  function clampNodeIntoRect(node, rectPx) {
    const box = node.getClientRect({ skipTransform: false });
    let dx = 0, dy = 0;
    if (box.x < rectPx.x) dx = rectPx.x - box.x;
    if (box.y < rectPx.y) dy = rectPx.y - box.y;
    if (box.x + box.width > rectPx.x + rectPx.width) dx = rectPx.x + rectPx.width - (box.x + box.width);
    if (box.y + box.height > rectPx.y + rectPx.height) dy = rectPx.y + rectPx.height - (box.y + box.height);
    if (dx || dy) node.position({ x: node.x() + dx, y: node.y() + dy });
  }

  function downloadDataUrl(dataUrl, filename) {
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  function lockBodyScroll() {
    const body = document.body;
    const prev = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      width: body.style.width
    };
    const scrollY = window.scrollY || 0;
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";
    return () => {
      body.style.overflow = prev.overflow;
      body.style.position = prev.position;
      body.style.top = prev.top;
      body.style.width = prev.width;
      window.scrollTo(0, scrollY);
    };
  }
  /* =======================
     END YOURAPP: Helpers
     ======================= */

  /* =========================
     BEGIN YOURAPP: Local background removal
     ========================= */
  function rgbDist(a, b) {
    const dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }
  function setAlpha(data, idx, alpha) { data[idx + 3] = alpha; }

  function sampleAvgColor(imgData, x, y, radius = 2) {
    const { data, width, height } = imgData;
    let r = 0, g = 0, b = 0, n = 0;
    for (let dy = -radius; dy <= radius; dy++) {
      for (let dx = -radius; dx <= radius; dx++) {
        const xx = Math.max(0, Math.min(width - 1, x + dx));
        const yy = Math.max(0, Math.min(height - 1, y + dy));
        const i = (yy * width + xx) * 4;
        r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
      }
    }
    return [Math.round(r / n), Math.round(g / n), Math.round(b / n)];
  }

  function decontaminateWhiteHalo(imgData, strength = 0.9) {
    const { data } = imgData;
    for (let i = 0; i < data.length; i += 4) {
      const a = data[i + 3];
      if (a === 0 || a === 255) continue;
      const r = data[i], g = data[i + 1], b = data[i + 2];
      const whiteness = Math.min(1, (r + g + b) / (3 * 255));
      const k = 1 - whiteness * strength;
      data[i] = Math.round(r * k);
      data[i + 1] = Math.round(g * k);
      data[i + 2] = Math.round(b * k);
    }
  }

  function erodeAlpha(imgData, iterations = 1) {
    const { data, width, height } = imgData;
    const idx = (x, y) => (y * width + x) * 4;
    for (let it = 0; it < iterations; it++) {
      const copy = new Uint8ClampedArray(data);
      for (let y = 1; y < height - 1; y++) {
        for (let x = 1; x < width - 1; x++) {
          const i = idx(x, y);
          const a = copy[i + 3];
          if (a === 0) continue;
          const n1 = copy[idx(x - 1, y) + 3];
          const n2 = copy[idx(x + 1, y) + 3];
          const n3 = copy[idx(x, y - 1) + 3];
          const n4 = copy[idx(x, y + 1) + 3];
          if (n1 === 0 || n2 === 0 || n3 === 0 || n4 === 0) data[i + 3] = Math.max(0, a - 35);
        }
      }
    }
  }

  async function removeBackgroundLocal(file, opts = {}) {
    const { tolerance = 30, feather = 1, maxSize = 1600 } = opts;

    const blobUrl = URL.createObjectURL(file);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = blobUrl;
    await img.decode();

    const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
    const W = Math.max(1, Math.round(img.width * scale));
    const H = Math.max(1, Math.round(img.height * scale));

    const canvas = document.createElement("canvas");
    canvas.width = W; canvas.height = H;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, W, H);
    URL.revokeObjectURL(blobUrl);

    const imgData = ctx.getImageData(0, 0, W, H);
    const data = imgData.data;

    const bgs = [
      sampleAvgColor(imgData, 0, 0),
      sampleAvgColor(imgData, W - 1, 0),
      sampleAvgColor(imgData, 0, H - 1),
      sampleAvgColor(imgData, W - 1, H - 1)
    ];

    function isBgLikeIdx(i) {
      const px = [data[i], data[i + 1], data[i + 2]];
      for (const bg of bgs) if (rgbDist(px, bg) <= tolerance) return true;
      return false;
    }

    const visited = new Uint8Array(W * H);
    const queue = new Int32Array(W * H);
    let qh = 0, qt = 0;

    function push(x, y) {
      const p = y * W + x;
      if (visited[p]) return;
      visited[p] = 1;
      queue[qt++] = p;
    }
    function isBgLikeXY(x, y) {
      const i = (y * W + x) * 4;
      return isBgLikeIdx(i);
    }

    push(0, 0); push(W - 1, 0); push(0, H - 1); push(W - 1, H - 1);

    while (qh < qt) {
      const p = queue[qh++];
      const x = p % W;
      const y = (p / W) | 0;
      if (!isBgLikeXY(x, y)) continue;
      const i = p * 4;
      setAlpha(data, i, 0);
      if (x > 0) push(x - 1, y);
      if (x < W - 1) push(x + 1, y);
      if (y > 0) push(x, y - 1);
      if (y < H - 1) push(x, y + 1);
    }

    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] === 0) continue;
      if (isBgLikeIdx(i)) data[i + 3] = 0;
    }

    if (feather > 0) {
      const copy = new Uint8ClampedArray(data);
      const rad = Math.min(3, Math.max(1, feather | 0));
      for (let y = 0; y < H; y++) {
        for (let x = 0; x < W; x++) {
          const p = y * W + x;
          const i = p * 4;
          if (copy[i + 3] !== 0) continue;
          for (let dy = -rad; dy <= rad; dy++) {
            for (let dx = -rad; dx <= rad; dx++) {
              const xx = x + dx, yy = y + dy;
              if (xx < 0 || xx >= W || yy < 0 || yy >= H) continue;
              const j = (yy * W + xx) * 4;
              if (data[j + 3] > 0) data[j + 3] = Math.min(data[j + 3], 220);
            }
          }
        }
      }
    }

    decontaminateWhiteHalo(imgData, 0.9);
    erodeAlpha(imgData, 1);

    ctx.putImageData(imgData, 0, 0);
    const outBlob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png", 1));
    if (!outBlob) throw new Error("toBlob failed");
    return outBlob;
  }
  /* =======================
     END YOURAPP: Local background removal
     ======================= */

  /* =========================
     BEGIN YOURAPP: Embroidery effect (satin-like, local, no deps)
     - Produces a stronger stitch + bevel/emboss look
     - Uses the logo's alpha as mask (keeps original colors)
     ========================= */
  async function applyEmbroideryEffectToHTMLImage(sourceImg, opts = {}) {
    const {
      maxSize = 1800,
      angleDeg = -25,
      stitchSpacing = 3,
      stitchLength = 14,
      threadWidth = 1.6,
      textureOpacity = 0.60,
      bevelStrength = 0.65,
      shadowStrength = 0.30,
      innerShadowStrength = 0.25,
      edgeStrength = 0.40
    } = opts;

    const iw = sourceImg.naturalWidth || sourceImg.width;
    const ih = sourceImg.naturalHeight || sourceImg.height;
    if (!iw || !ih) throw new Error("invalid source image");

    const scale = Math.min(1, maxSize / Math.max(iw, ih));
    const W = Math.max(1, Math.round(iw * scale));
    const H = Math.max(1, Math.round(ih * scale));

    // Base canvas: original logo
    const base = document.createElement("canvas");
    base.width = W;
    base.height = H;
    const bctx = base.getContext("2d", { willReadFrequently: true });
    bctx.clearRect(0, 0, W, H);
    bctx.drawImage(sourceImg, 0, 0, W, H);

    // Alpha mask
    const mask = document.createElement("canvas");
    mask.width = W;
    mask.height = H;
    const mctx = mask.getContext("2d", { willReadFrequently: true });
    mctx.drawImage(base, 0, 0);

    // Texture (stitches)
    const tex = document.createElement("canvas");
    tex.width = W;
    tex.height = H;
    const tctx = tex.getContext("2d");
    tctx.clearRect(0, 0, W, H);

    const ang = (angleDeg * Math.PI) / 180;
    const dx = Math.cos(ang);
    const dy = Math.sin(ang);

    tctx.lineWidth = threadWidth;
    tctx.lineCap = "round";

    // draw lots of diagonal stitch segments, alternating light/dark rows
    for (let y = -H; y < H * 2; y += stitchSpacing) {
      const row = ((y / stitchSpacing) | 0);
      const light = (row % 2 === 0);

      tctx.strokeStyle = light ? "rgba(255,255,255,0.95)" : "rgba(0,0,0,0.85)";
      tctx.beginPath();

      for (let x = -W; x < W * 2; x += stitchLength + 2) {
        const sx = x;
        const sy = y;
        const ex = sx + dx * stitchLength;
        const ey = sy + dy * stitchLength;
        tctx.moveTo(sx, sy);
        tctx.lineTo(ex, ey);
      }
      tctx.stroke();
    }

    // mask stitches to logo alpha
    tctx.globalCompositeOperation = "destination-in";
    tctx.drawImage(mask, 0, 0);
    tctx.globalCompositeOperation = "source-over";

    // Output canvas
    const out = document.createElement("canvas");
    out.width = W;
    out.height = H;
    const octx = out.getContext("2d", { willReadFrequently: true });

    // 1) base logo
    octx.drawImage(base, 0, 0);

    // 2) stitches overlay (contrast)
    octx.save();
    octx.globalCompositeOperation = "overlay";
    octx.globalAlpha = textureOpacity;
    octx.drawImage(tex, 0, 0);
    octx.restore();

    // 3) edge darkening (gives embroidered border)
    if (edgeStrength > 0) {
      const edge = document.createElement("canvas");
      edge.width = W; edge.height = H;
      const ectx = edge.getContext("2d", { willReadFrequently: true });
      ectx.clearRect(0, 0, W, H);

      // blur the alpha mask and subtract a smaller blur to approximate edge
      ectx.drawImage(mask, 0, 0);
      ectx.globalCompositeOperation = "source-in";
      ectx.fillStyle = "rgba(0,0,0,1)";
      ectx.fillRect(0, 0, W, H);

      octx.save();
      octx.globalCompositeOperation = "multiply";
      octx.globalAlpha = edgeStrength;
      octx.filter = "blur(0.6px)";
      octx.drawImage(edge, 0, 0);
      octx.restore();
    }

    // 4) bevel/emboss-ish using shadow + highlight shifts
    if (bevelStrength > 0) {
      // shadow (down-right)
      octx.save();
      octx.globalCompositeOperation = "source-atop";
      octx.globalAlpha = Math.min(0.55, bevelStrength * 0.55);
      octx.filter = "blur(1px)";
      octx.drawImage(mask, 1, 1);
      octx.restore();

      // highlight (up-left) - white tinted
      const hi = document.createElement("canvas");
      hi.width = W; hi.height = H;
      const hctx = hi.getContext("2d", { willReadFrequently: true });
      hctx.drawImage(mask, 0, 0);
      hctx.globalCompositeOperation = "source-in";
      hctx.fillStyle = "rgba(255,255,255,1)";
      hctx.fillRect(0, 0, W, H);

      octx.save();
      octx.globalCompositeOperation = "screen";
      octx.globalAlpha = Math.min(0.55, bevelStrength * 0.55);
      octx.filter = "blur(0.8px)";
      octx.drawImage(hi, -1, -1);
      octx.restore();
    }

    // 5) cast shadow (soft)
    if (shadowStrength > 0) {
      const sh = document.createElement("canvas");
      sh.width = W; sh.height = H;
      const sctx = sh.getContext("2d");
      sctx.drawImage(mask, 0, 0);
      sctx.globalCompositeOperation = "source-in";
      sctx.fillStyle = "rgba(0,0,0,1)";
      sctx.fillRect(0, 0, W, H);

      octx.save();
      octx.globalCompositeOperation = "destination-over";
      octx.globalAlpha = shadowStrength;
      octx.filter = "blur(2px)";
      octx.drawImage(sh, 2, 2);
      octx.restore();
    }

    // 6) inner shadow (adds depth)
    if (innerShadowStrength > 0) {
      const inner = document.createElement("canvas");
      inner.width = W; inner.height = H;
      const ictx = inner.getContext("2d", { willReadFrequently: true });
      ictx.drawImage(mask, 0, 0);
      ictx.globalCompositeOperation = "source-in";
      ictx.fillStyle = "rgba(0,0,0,1)";
      ictx.fillRect(0, 0, W, H);

      octx.save();
      octx.globalCompositeOperation = "multiply";
      octx.globalAlpha = innerShadowStrength;
      octx.filter = "blur(1.2px)";
      octx.drawImage(inner, 0, 0);
      octx.restore();
    }

    // Export to HTMLImageElement (can throw if tainted)
    const outUrl = out.toDataURL("image/png");
    const outImg = new Image();
    outImg.src = outUrl;
    await outImg.decode();
    return outImg;
  }
  /* =======================
     END YOURAPP: Embroidery effect
     ======================= */

  /* =========================
     BEGIN YOURAPP: Modal styles (responsive)
     ========================= */
  function ensureModalStyles() {
    if (document.getElementById("lm-styles")) return;
    const style = document.createElement("style");
    style.id = "lm-styles";
    style.textContent = `
      .lm-backdrop { padding: 8vh 16px; }
      .lm-modal { max-width: 1200px; width: 100%; border-radius: 14px; max-height: 84vh; overflow: hidden; background:#fff; box-shadow:0 10px 35px rgba(0,0,0,.25); }
      .lm-body { display:flex; gap:14px; padding:0 14px 14px 14px; align-items:stretch; }
      .lm-left { flex:1 1 auto; min-width:520px; }
      .lm-stage { width:100%; height: calc(84vh - 86px); min-height:460px; border:1px solid #ddd; border-radius:12px; overflow:hidden; background:#f8f8f8; }
      .lm-right { width:380px; max-width:42vw; display:flex; flex-direction:column; gap:12px; overflow:auto; padding-right:4px; }
      .lm-card { border:1px solid #eee; border-radius:12px; padding:12px; }
      .lm-thumbs { display:grid; grid-template-columns:repeat(4, 1fr); gap:10px; }
      .lm-arrow { position:absolute; top:50%; transform:translateY(-50%); z-index:2; width:34px; height:34px; border-radius:999px; border:1px solid #ddd; background:#fff; box-shadow:0 6px 18px rgba(0,0,0,.12); cursor:pointer; display:flex; align-items:center; justify-content:center; }
      .lm-arrow-left { left:-6px; }
      .lm-arrow-right { right:-6px; }

      @media (max-width: 900px) {
        .lm-backdrop {
          padding: calc(env(safe-area-inset-top) + 8px) 8px calc(env(safe-area-inset-bottom) + 8px) 8px;
          align-items: stretch;
        }
        .lm-modal {
          max-width: 100%;
          max-height: 100svh;
          height: 100svh;
          border-radius: 12px;
          overflow: hidden;
        }
        .lm-body {
          flex-direction: column;
          padding: 0 10px 10px 10px;
          gap: 10px;
          height: calc(100svh - 58px);
          overflow: hidden;
        }
        .lm-left { min-width: 0; }
        .lm-stage {
          height: 46svh;
          min-height: 320px;
        }
        .lm-right {
          width: 100%;
          max-width: 100%;
          overflow: auto;
          padding-right: 0;
        }
        .lm-thumbs { grid-template-columns:repeat(3, 1fr); }
        .lm-arrow { width:38px; height:38px; }
      }
    `;
    document.head.appendChild(style);
  }

  function openModal() {
    ensureModalStyles();

    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="lm-backdrop" style="position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99999;display:flex;justify-content:center;">
        <div class="lm-modal">
          <div style="display:flex;align-items:center;justify-content:space-between;padding:14px 14px 8px 14px;">
            <strong id="lm-title" style="font-size:18px;"></strong>
            <button type="button" data-close style="font-size:22px;line-height:1;border:0;background:transparent;cursor:pointer;">✕</button>
          </div>

          <div class="lm-body">
            <div class="lm-left">
              <div id="lm-stage" class="lm-stage"></div>
            </div>

            <div class="lm-right">
              <div class="lm-card">
                <div style="font-weight:600;margin-bottom:8px;">${t("actions")}</div>

                <label for="lm-file"
                  style="display:inline-flex;align-items:center;gap:8px;border:1px solid #bbb;border-radius:8px;padding:10px 12px;cursor:pointer;user-select:none;width:100%;justify-content:space-between;">
                  <span>
                    <span id="lm-file-label-main" style="font-weight:600;"></span>
                    <span id="lm-file-label-accepted" style="opacity:.7;font-size:12px;margin-left:6px;"></span>
                  </span>
                  <span style="opacity:.6;font-size:12px;">↗</span>
                </label>

                <input type="file" id="lm-file"
                  accept=".svg,.png,.jpg,.jpeg,image/svg+xml,image/png,image/jpeg"
                  style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;" />

                <div id="lm-file-name" style="margin-top:8px;opacity:.75;font-size:13px;"></div>

                <div style="display:flex;gap:10px;align-items:center;margin-top:12px;flex-wrap:wrap;">
                  <button type="button" id="lm-removebg" style="padding:10px 12px;border-radius:8px;border:1px solid #bbb;background:#fff;cursor:pointer;"></button>
                  <button type="button" id="lm-download" style="padding:10px 12px;border-radius:8px;border:1px solid #111;background:#111;color:#fff;cursor:pointer;"></button>
                </div>

                <div style="display:flex;flex-direction:column;gap:6px;margin-top:12px;max-width:300px;">
                  <div style="display:flex;justify-content:space-between;gap:12px;align-items:center;">
                    <label for="lm-tol" id="lm-tol-label" style="font-size:13px;opacity:.85;"></label>
                    <span id="lm-tol-val" style="font-size:13px;opacity:.85;"></span>
                  </div>
                  <input type="range" id="lm-tol" min="10" max="70" step="1" value="30" style="width:300px;max-width:100%;">
                  <small id="lm-tol-help" style="opacity:.65;line-height:1.35;"></small>
                </div>

                <div id="lm-msg" style="margin-top:10px;opacity:.75;font-size:13px;min-height:18px;"></div>
              </div>

              <div class="lm-card">
                <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;">
                  <div style="font-weight:600;">${t("pickImage")}</div>
                  <div id="lm-page-indicator" style="opacity:.75;font-size:12px;"></div>
                </div>

                <div style="position:relative;">
                  <button type="button" id="lm-prev-page" class="lm-arrow lm-arrow-left">‹</button>
                  <button type="button" id="lm-next-page" class="lm-arrow lm-arrow-right">›</button>
                  <div id="lm-thumbs" class="lm-thumbs"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);
    return wrap;
  }
  /* =======================
     END YOURAPP: Modal builder
     ======================= */

  /* =========================
     BEGIN YOURAPP: Main editor flow
     ========================= */
  async function runEditor() {
    if (!Array.isArray(images) || images.length === 0) return;

    const unlockScroll = lockBodyScroll();
    const modal = openModal();

    // elements
    const stageEl = modal.querySelector("#lm-stage");
    const thumbsEl = modal.querySelector("#lm-thumbs");
    const prevPageBtn = modal.querySelector("#lm-prev-page");
    const nextPageBtn = modal.querySelector("#lm-next-page");
    const pageIndicator = modal.querySelector("#lm-page-indicator");
    const fileNameEl = modal.querySelector("#lm-file-name");
    const msgEl = modal.querySelector("#lm-msg");
    const tolInput = modal.querySelector("#lm-tol");
    const tolVal = modal.querySelector("#lm-tol-val");

    // close
    const onResizeHard = () => {}; // placeholder; reassigned later
    const closeModal = () => {
      modal.remove();
      unlockScroll();
      window.removeEventListener("resize", onResizeHard);
      window.removeEventListener("orientationchange", onResizeHard);
      if (window.visualViewport) window.visualViewport.removeEventListener("resize", onResizeHard);
    };

    modal.querySelector("#lm-title").textContent = t("title");
    modal.querySelector("#lm-removebg").textContent = t("removeBg");
    modal.querySelector("#lm-download").textContent = t("download");
    modal.querySelector("#lm-tol-label").textContent = t("bgSensitivity");
    modal.querySelector("#lm-tol-help").textContent = t("bgSensitivityHelp");
    modal.querySelector("#lm-file-label-main").textContent = t("chooseLogo");
    modal.querySelector("#lm-file-label-accepted").textContent = t("accepted");
    fileNameEl.textContent = t("noFile");

    modal.querySelector("[data-close]").onclick = closeModal;
    modal.querySelector(".lm-backdrop").addEventListener("click", (e) => {
      if (e.target.classList.contains("lm-backdrop")) closeModal();
    });

    // stage sizing
    const { w: W0, h: H0 } = await waitForLayout(stageEl);
    if (!W0 || !H0) {
      msgEl.textContent = t("editorNotReady");
      return;
    }

    const stage = new Konva.Stage({ container: stageEl, width: W0, height: H0 });
    const layer = new Konva.Layer();
    stage.add(layer);

    // zone
    const zoneRel = { ...zoneRelDefault };
    const zonePx = { x: zoneRel.x * W0, y: zoneRel.y * H0, width: zoneRel.w * W0, height: zoneRel.h * H0 };

    // thumbs paging
    const PAGE_SIZE = 12;
    let selectedIndex = 0;
    let selectedBgUrl = images[selectedIndex]?.src || images[selectedIndex]?.thumb;
    let pageIndex = Math.floor(selectedIndex / PAGE_SIZE);
    const pageCount = Math.max(1, Math.ceil(images.length / PAGE_SIZE));

    // background
    msgEl.textContent = t("loadingImg");
    let bgImg;
    try {
      bgImg = await loadImage(selectedBgUrl);
    } catch {
      const fallback = images[selectedIndex]?.thumb || images[selectedIndex]?.src;
      selectedBgUrl = fallback;
      bgImg = await loadImage(fallback);
    }

    const bgFit0 = fitRectContainLeftCenter(bgImg.width, bgImg.height, W0, H0);
    const bg = new Konva.Image({ image: bgImg, ...bgFit0, listening: false });
    layer.add(bg);

    let bgExportRect = { x: bgFit0.x, y: bgFit0.y, width: bgFit0.width, height: bgFit0.height };

    // logo state
    let logoNode = null;
    let logoTransformer = null;
    let currentLogoFile = null;

    // embroidery apply state
    let logoVersion = 0;
    let lastEmbroideryApplied = -1;

    // transformer tuning for mobile
    const transformerAnchorSize = isMobile() ? 18 : 10;
    const transformerRotateOffset = isMobile() ? 34 : 18;
    const SNAP_15 = [0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180, 195, 210, 225, 240, 255, 270, 285, 300, 315, 330, 345];

    function attachLogoTransformer(node) {
      if (logoTransformer) logoTransformer.destroy();

      logoTransformer = new Konva.Transformer({
        nodes: [node],
        keepRatio: true,
        enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
        rotateEnabled: true,
        rotationSnaps: SNAP_15,
        rotationSnapTolerance: 5,
        anchorSize: transformerAnchorSize,
        rotateAnchorOffset: transformerRotateOffset,
        borderStrokeWidth: isMobile() ? 2 : 1
      });

      layer.add(logoTransformer);

      // SHIFT = free rotation (desktop only)
      const keydown = (e) => {
        if (e.key === "Shift" && logoTransformer) {
          logoTransformer.rotationSnaps([]);
          layer.batchDraw();
        }
      };
      const keyup = (e) => {
        if (e.key === "Shift" && logoTransformer) {
          logoTransformer.rotationSnaps(SNAP_15);
          layer.batchDraw();
        }
      };
      window.addEventListener("keydown", keydown);
      window.addEventListener("keyup", keyup);

      const oldDestroy = logoTransformer.destroy.bind(logoTransformer);
      logoTransformer.destroy = () => {
        window.removeEventListener("keydown", keydown);
        window.removeEventListener("keyup", keyup);
        oldDestroy();
      };
    }

    async function applyEmbroideryIfNeeded() {
      if (!SHOULD_AUTO_EMBROIDER()) return;
      if (!logoNode) return;
      if (lastEmbroideryApplied === logoVersion) return;

      try {
        msgEl.textContent = t("embroidering");
        const srcImg = logoNode.image();
        if (!srcImg) throw new Error("no logo image");

        const embImg = await applyEmbroideryEffectToHTMLImage(srcImg, EMBROIDERY_SETTINGS);
        logoNode.image(embImg);
        layer.batchDraw();

        lastEmbroideryApplied = logoVersion;
        msgEl.textContent = t("embroideryOk");
        setTimeout(() => { if (msgEl) msgEl.textContent = ""; }, 900);
      } catch {
        msgEl.textContent = t("embroideryFail");
      }
    }

    async function setLogoFromFile(file) {
      const url = URL.createObjectURL(file);
      const img = await loadImage(url);
      currentLogoFile = file;

      if (logoNode) logoNode.destroy();

      const baseRect = hasZone ? zonePx : bgExportRect;
      const targetW = baseRect.width * 0.35;
      const scale = targetW / img.width;

      logoNode = new Konva.Image({
        image: img,
        x: baseRect.x + baseRect.width * 0.45,
        y: baseRect.y + baseRect.height * 0.5 - (img.height * scale) / 2,
        draggable: true,
        scaleX: scale,
        scaleY: scale,
        rotation: 0
      });

      logoNode.on("dragmove transform", () => {
        if (hasZone) clampNodeIntoRect(logoNode, zonePx);
        else clampNodeIntoRect(logoNode, bgExportRect);
        layer.batchDraw();
      });

      layer.add(logoNode);
      attachLogoTransformer(logoNode);
      layer.draw();

      // mark new logo + auto embroidery
      logoVersion++;
      await applyEmbroideryIfNeeded();
    }

    async function setLogoFromHTMLImage(img, fileForUpload) {
      currentLogoFile = fileForUpload;

      if (logoNode) logoNode.destroy();

      const baseRect = hasZone ? zonePx : bgExportRect;
      const targetW = baseRect.width * 0.35;
      const scale = targetW / img.width;

      logoNode = new Konva.Image({
        image: img,
        x: baseRect.x + baseRect.width * 0.45,
        y: baseRect.y + baseRect.height * 0.5 - (img.height * scale) / 2,
        draggable: true,
        scaleX: scale,
        scaleY: scale,
        rotation: 0
      });

      logoNode.on("dragmove transform", () => {
        if (hasZone) clampNodeIntoRect(logoNode, zonePx);
        else clampNodeIntoRect(logoNode, bgExportRect);
        layer.batchDraw();
      });

      layer.add(logoNode);
      attachLogoTransformer(logoNode);
      layer.draw();

      // mark new logo + auto embroidery
      logoVersion++;
      await applyEmbroideryIfNeeded();
    }

    function updatePageIndicator() {
      pageIndicator.textContent = `${pageIndex + 1} / ${pageCount}`;
    }

    function renderThumbsPage() {
      const start = pageIndex * PAGE_SIZE;
      const end = Math.min(images.length, start + PAGE_SIZE);

      thumbsEl.innerHTML = "";
      for (let i = start; i < end; i++) {
        const it = images[i];
        const thumb = it.thumb || it.src || "";
        const btn = document.createElement("button");
        btn.type = "button";
        btn.dataset.index = String(i);
        btn.style.cssText =
          "border:1px solid #ddd;border-radius:10px;padding:0;overflow:hidden;background:#fff;cursor:pointer;width:100%;aspect-ratio:1/1;";
        if (i === selectedIndex) {
          btn.style.outline = "2px solid rgba(17,17,17,.8)";
          btn.style.outlineOffset = "2px";
        }
        btn.innerHTML = `<img src="${thumb}" alt="" style="display:block;width:100%;height:100%;object-fit:cover;">`;
        thumbsEl.appendChild(btn);
      }

      const showArrows = pageCount > 1;
      prevPageBtn.style.display = showArrows ? "flex" : "none";
      nextPageBtn.style.display = showArrows ? "flex" : "none";
      updatePageIndicator();
    }

    async function setBackgroundByIndex(idx) {
      if (!images[idx]) return;

      selectedIndex = idx;
      selectedBgUrl = images[selectedIndex]?.src || images[selectedIndex]?.thumb;

      const wantPage = Math.floor(selectedIndex / PAGE_SIZE);
      if (wantPage !== pageIndex) pageIndex = wantPage;

      renderThumbsPage();

      try {
        msgEl.textContent = t("changeImg");

        let newImg;
        try {
          newImg = await loadImage(selectedBgUrl);
        } catch {
          const fallback = images[selectedIndex]?.thumb || images[selectedIndex]?.src;
          selectedBgUrl = fallback;
          newImg = await loadImage(fallback);
        }

        bg.image(newImg);

        const fit = fitRectContainLeftCenter(newImg.width, newImg.height, stage.width(), stage.height());
        bg.position({ x: fit.x, y: fit.y });
        bg.size({ width: fit.width, height: fit.height });
        bgExportRect = { x: fit.x, y: fit.y, width: fit.width, height: fit.height };

        if (logoNode && !hasZone) clampNodeIntoRect(logoNode, bgExportRect);

        layer.batchDraw();
        msgEl.textContent = "";
      } catch {
        msgEl.textContent = "";
      }
    }

    // bind thumbs
    thumbsEl.addEventListener("click", (e) => {
      const btn = e.target.closest("button[data-index]");
      if (!btn) return;
      setBackgroundByIndex(Number(btn.dataset.index));
    });

    prevPageBtn.addEventListener("click", () => {
      pageIndex = (pageIndex - 1 + pageCount) % pageCount;
      renderThumbsPage();
    });
    nextPageBtn.addEventListener("click", () => {
      pageIndex = (pageIndex + 1) % pageCount;
      renderThumbsPage();
    });

    renderThumbsPage();

    // DPO logo load (optional)
    const dpoInput = document.querySelector(dpoSelector);
    if (dpoInput?.value && /^https?:\/\//.test(dpoInput.value)) {
      try {
        msgEl.textContent = t("loadingLogo");
        const blob = await fetchBlob(dpoInput.value);
        const mime = blob.type || "";
        if (mime === "image/svg+xml") {
          const svgFile = fileFromBlob(blob, "logo-from-dpo.svg");
          const img = await svgFileToHTMLImage(svgFile);
          await setLogoFromHTMLImage(img, svgFile);
        } else {
          const f = fileFromBlob(blob, "logo-from-dpo");
          await setLogoFromFile(f);
        }
        msgEl.textContent = "";
      } catch {
        msgEl.textContent = t("uploadHint");
      }
    } else {
      msgEl.textContent = t("uploadHint");
    }

    // slider UI
    const updateTolUI = () => { tolVal.textContent = String(Number(tolInput.value || 30)); };
    updateTolUI();
    tolInput.addEventListener("input", updateTolUI);

    // upload
    modal.querySelector("#lm-file").addEventListener("change", async (ev) => {
      const f = ev.target.files?.[0];
      fileNameEl.textContent = f?.name || t("noFile");
      if (!f) return;

      const ext = extOf(f.name);

      if (isSvgExt(ext) || f.type === "image/svg+xml") {
        try {
          msgEl.textContent = t("loadingLogo");
          const img = await svgFileToHTMLImage(f);
          await setLogoFromHTMLImage(img, f);
          msgEl.textContent = "";
        } catch {
          msgEl.textContent = t("unsupported");
        }
        return;
      }

      if (isRasterExt(ext) || f.type === "image/png" || f.type === "image/jpeg") {
        msgEl.textContent = t("loadingLogo");
        await setLogoFromFile(f);
        msgEl.textContent = "";
        return;
      }

      msgEl.textContent = t("unsupported");
    });

    // remove background
    modal.querySelector("#lm-removebg").onclick = async () => {
      if (!currentLogoFile) return (msgEl.textContent = t("needLogo"));
      const ext = extOf(currentLogoFile.name);
      if (!isRasterExt(ext)) return (msgEl.textContent = t("svgNoBg"));

      try {
        const tol = Number(tolInput.value || 30);
        msgEl.textContent = t("removingBg");
        const outBlob = await removeBackgroundLocal(currentLogoFile, {
          tolerance: tol,
          feather: 1,
          maxSize: 1600
        });
        const outFile = new File([outBlob], "logo-nobg.png", { type: "image/png" });
        await setLogoFromFile(outFile);
        msgEl.textContent = t("removedBgOk");
        setTimeout(() => { msgEl.textContent = ""; }, 1200);
      } catch {
        msgEl.textContent = t("errBg");
      }
    };

    // download mockup
    modal.querySelector("#lm-download").onclick = async () => {
      if (!logoNode) return (msgEl.textContent = t("previewRequired"));
      msgEl.textContent = t("downloading");

      const prevTransformerVisible = logoTransformer ? logoTransformer.visible() : false;
      if (logoTransformer) { logoTransformer.visible(false); layer.draw(); }

      const dataUrl = stage.toDataURL({
        pixelRatio: 2,
        x: bgExportRect.x,
        y: bgExportRect.y,
        width: bgExportRect.width,
        height: bgExportRect.height
      });

      if (logoTransformer) { logoTransformer.visible(prevTransformerVisible); layer.draw(); }

      downloadDataUrl(dataUrl, `mockup-${Date.now()}.png`);
      setTimeout(() => { msgEl.textContent = ""; }, 600);
    };

    // resize handling
    const resizeHandler = () => {
      const rect = stageEl.getBoundingClientRect();
      const w = Math.round(rect.width);
      const h = Math.round(rect.height);
      if (!w || !h) return;

      stage.size({ width: w, height: h });

      const img = bg.image();
      if (img) {
        const fit = fitRectContainLeftCenter(img.width, img.height, w, h);
        bg.position({ x: fit.x, y: fit.y });
        bg.size({ width: fit.width, height: fit.height });
        bgExportRect = { x: fit.x, y: fit.y, width: fit.width, height: fit.height };
        if (logoNode && !hasZone) clampNodeIntoRect(logoNode, bgExportRect);
      }

      layer.batchDraw();
    };

    // overwrite placeholder to allow proper removeEventListener
    Object.assign(onResizeHard, resizeHandler);

    window.addEventListener("resize", resizeHandler, { passive: true });
    window.addEventListener("orientationchange", resizeHandler, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener("resize", resizeHandler, { passive: true });

    msgEl.textContent = "";
    layer.draw();
  }
  /* =======================
     END YOURAPP: Main editor flow
     ======================= */

  /* =========================
     BEGIN YOURAPP: Button binding
     ========================= */
  document.addEventListener("click", (e) => {
    if (!e.target.closest("#logo-mockup-open")) return;
    runEditor();
  });
  /* =======================
     END YOURAPP: Button binding
     ======================= */
})();